<template>
    <el-drawer
        title="复制选项"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :size="480"
        append-to-body
        @close="close"
    >
        <div class="drawer-content">
            <div class="item MT20">
                富文本代码:
                <el-row :gutter="10" class="MT20">
                    <el-col :span="20"><el-input v-model="value1" size="medium" ref="value1" readonly></el-input></el-col>
                    <el-col :span="4"><el-button type="primary" size="medium" @click="copy('value1')">复制</el-button></el-col>
                </el-row>
            </div>
            <div class="item MT20">
                视频ID:
                <el-row :gutter="10" class="MT20">
                    <el-col :span="20"><el-input v-model="value2" size="medium" ref="value2" readonly></el-input></el-col>
                    <el-col :span="4"><el-button type="primary" size="medium" @click="copy('value2')">复制</el-button></el-col>
                </el-row>
            </div>
            <div class="item MT20">
                视频地址:
                <el-row :gutter="10" class="MT20">
                    <el-col :span="20"><el-input v-model="value3" size="medium" ref="value3" readonly></el-input></el-col>
                    <el-col :span="4"><el-button type="primary" size="medium" @click="copy('value3')">复制</el-button></el-col>
                </el-row>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            drawerShow: false,
            data: null,
            sswap: process.env.VUE_APP_SSWAP_URL,
            value1: '',
            value2: '',
            value3: '',
            copyTimer: null,
        };
    },
    methods: {
        close() {
            this.drawerShow = false;
        },
        show(data) {
            this.data = data;
            this.value2 = this.data.id;
            this.value1 = `<iframe height=498 width=510 src='${this.sswap}/pages/tool/mvideo/mvideo?id=${this.value2}' frameborder=0 'allowfullscreen'></iframe>`;
            this.value3 = `${this.sswap}/pages/tool/videodetails/videodetails?id=${this.value2}`;
            this.drawerShow = true;
        },
        //复制链接
        copy(input){
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs[input];
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
    },
};
</script>
